import { z } from 'zod';

import type { HoldingUnitEvent } from './holding-unit-event.dto.js';
import { FixedIdAssetEventSchema } from './fixed-id-assets-events.schema.js';
import { HoldingUnitAndLoadSessionEventSchema } from './holding-units-events.schema.js';

export const HoldingUnitEventSchema: z.ZodType<HoldingUnitEvent> = z.union([
  HoldingUnitAndLoadSessionEventSchema,
  FixedIdAssetEventSchema,
]);
